import { Component, Input, ViewChild, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-dailymotion.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["dailymotion"];
class NgxDailymotionComponent {
    constructor() {
        this.video = '';
        this.width = 480;
        this.height = 270;
        this.autoplay = false;
        this.autoplayMute = false;
        this.controls = false;
        this.mute = false;
        this.quality = 'auto';
        this.sharingEnable = false;
        this.uiLogo = false;
        this.start = 0;
        this.uiTheme = 'dark';
        this.volume = 0.5;
        this.pause = false;
        this.player = null;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (!this.video) {
            return;
        }
        // https://developer.dailymotion.com/player/#player-parameters
        /** @type {?} */
        const options = {
            video: this.video,
            width: this.width,
            height: this.height,
            params: {
                autoplay: this.autoplay,
                controls: this.controls,
                'ui-logo': this.uiLogo,
                'ui-theme': this.uiTheme
            }
        };
        this.player = window.DM.player(this.div.nativeElement, options);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!this.player) {
            return;
        }
        for (const propName in changes) {
            if (propName === 'video') {
                // https://developer.dailymotion.com/player/#player-parameters
                /** @type {?} */
                const options = {
                    video: this.video
                };
                this.player.load(options);
            }
            else if (propName === 'controls') {
                this.player.setControls(this.controls);
            }
            else if (propName === 'pause') {
                if (changes[propName].currentValue === 'true') {
                    this.player.pause();
                }
                else {
                    this.player.play();
                }
            }
            else if (propName === 'quality') {
                this.player.setQuality(changes[propName].currentValue);
            }
            else if (propName === 'volume') {
                this.player.setVolume(changes[propName].currentValue);
            }
        }
    }
}
NgxDailymotionComponent.ɵfac = function NgxDailymotionComponent_Factory(t) { return new (t || NgxDailymotionComponent)(); };
NgxDailymotionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxDailymotionComponent, selectors: [["dailymotion"]], viewQuery: function NgxDailymotionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.div = _t.first);
    } }, inputs: { video: "video", width: "width", height: "height", autoplay: "autoplay", autoplayMute: "autoplayMute", controls: "controls", mute: "mute", quality: "quality", sharingEnable: "sharingEnable", uiLogo: "uiLogo", start: "start", uiTheme: "uiTheme", volume: "volume", pause: "pause" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["dailymotion", ""]], template: function NgxDailymotionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", null, 0);
    } }, encapsulation: 2 });
/** @nocollapse */
NgxDailymotionComponent.ctorParameters = () => [];
NgxDailymotionComponent.propDecorators = {
    video: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    autoplay: [{ type: Input }],
    autoplayMute: [{ type: Input }],
    controls: [{ type: Input }],
    mute: [{ type: Input }],
    quality: [{ type: Input }],
    sharingEnable: [{ type: Input }],
    uiLogo: [{ type: Input }],
    start: [{ type: Input }],
    uiTheme: [{ type: Input }],
    volume: [{ type: Input }],
    pause: [{ type: Input }],
    div: [{ type: ViewChild, args: ['dailymotion', { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDailymotionComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line component-selector
                selector: 'dailymotion',
                template: `<div #dailymotion></div>`
            }]
    }], function () { return []; }, { video: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], autoplay: [{
            type: Input
        }], autoplayMute: [{
            type: Input
        }], controls: [{
            type: Input
        }], mute: [{
            type: Input
        }], quality: [{
            type: Input
        }], sharingEnable: [{
            type: Input
        }], uiLogo: [{
            type: Input
        }], start: [{
            type: Input
        }], uiTheme: [{
            type: Input
        }], volume: [{
            type: Input
        }], pause: [{
            type: Input
        }], div: [{
            type: ViewChild,
            args: ['dailymotion', { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    NgxDailymotionComponent.prototype.video;
    /** @type {?} */
    NgxDailymotionComponent.prototype.width;
    /** @type {?} */
    NgxDailymotionComponent.prototype.height;
    /** @type {?} */
    NgxDailymotionComponent.prototype.autoplay;
    /** @type {?} */
    NgxDailymotionComponent.prototype.autoplayMute;
    /** @type {?} */
    NgxDailymotionComponent.prototype.controls;
    /** @type {?} */
    NgxDailymotionComponent.prototype.mute;
    /** @type {?} */
    NgxDailymotionComponent.prototype.quality;
    /** @type {?} */
    NgxDailymotionComponent.prototype.sharingEnable;
    /** @type {?} */
    NgxDailymotionComponent.prototype.uiLogo;
    /** @type {?} */
    NgxDailymotionComponent.prototype.start;
    /** @type {?} */
    NgxDailymotionComponent.prototype.uiTheme;
    /** @type {?} */
    NgxDailymotionComponent.prototype.volume;
    /** @type {?} */
    NgxDailymotionComponent.prototype.pause;
    /** @type {?} */
    NgxDailymotionComponent.prototype.div;
    /** @type {?} */
    NgxDailymotionComponent.prototype.player;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-dailymotion.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxDailymotionModule {
}
NgxDailymotionModule.ɵfac = function NgxDailymotionModule_Factory(t) { return new (t || NgxDailymotionModule)(); };
NgxDailymotionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxDailymotionModule });
NgxDailymotionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDailymotionModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxDailymotionComponent],
                imports: [],
                exports: [NgxDailymotionComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxDailymotionModule, { declarations: [NgxDailymotionComponent], exports: [NgxDailymotionComponent] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-dailymotion.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxDailymotionComponent, NgxDailymotionModule };

